import React, { useEffect, useState } from "react";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import { useGetImagePathByIdQuery } from "features/onboarding/users/farmer/farmerApiSlice";
import { DataGrid } from "@mui/x-data-grid";
import StateDistrict from "features/onboarding/users/farmer/StateDistrict";
import CustomSearchBar from "components/CustomSearchBar";
import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import { API_URL } from "app/config";
import { store } from "app/store";
import { Table } from "reactstrap";
import {
  useGetCrmInsuranceLeadsQuery,
  useUploadInsuranceFarmerDocsMutation,
} from "features/Insurance/InsuranceApiSlice";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
export const InsuranceTaskDownload = ({ orgId }) => {
  const [selectedFarmerIds, setSelectedFarmerIds] = useState([]);
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [farmerRows, setfarmerRows] = useState([]);
  const [multipleDownloadFarmers] = useUploadInsuranceFarmerDocsMutation();
  const [sendImagePath, setImagePath] = useState("");
  const { data: pathImage, refetch: pathRefetch } = useGetImagePathByIdQuery(
    sendImagePath
  );
  const [statusName, setStatusName] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 50,
  });

  const queryParameters = {
  page: pagination.page,
   perPage: pagination.perPage,
      searchKey: debouncedSearch,
    selectedProduct: "Cattle",
    stateCode: state_id,
    districtCode: district_id,
    blockCode: "",
    statusName: statusName,
    statusIncludes: "Proposal Form Submitted",
  };
  const {
    data: farmerData,
    isLoading: farmerLoading,
    isFetching,
    refetch,
  } = useGetCrmInsuranceLeadsQuery(queryParameters);
  const [showDownloads, setShowDownloads] = useState(false);
  const [reportingData, setReportingData] = useState([]);

  useEffect(() => {
    const currentPage = farmerData?.data?.current_page || pagination.page;
  const totalPages = farmerData?.data?.pages || pagination.pageCount;
  const perPageFromApi = farmerData?.data?.per_page || pagination.perPage;
    setfarmerRows(farmerData?.data?.results ? farmerData?.data?.results : []);
    setPagination(prev => {
    if (
      prev.page !== currentPage ||
      prev.pageCount !== totalPages ||
      prev.perPage !== perPageFromApi
    ) {
      return {
        page: currentPage,
        pageCount: totalPages,
        perPage: perPageFromApi,
      };
    }
    return prev;
  });


  }, [farmerData]);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const state = store.getState();
        const url = `${API_URL}/api/v1/onboarding/services/tasks`;
        const response = await fetch(url, {
          headers: { authorization: `Bearer ${state.auth.accessToken}` },
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();

        const filteredData =
          data?.data?.filter(
            (item) => item.results?.task_type === "documents_zip"
          ) || [];

        setReportingData(filteredData);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    if (showDownloads) {
      fetchDashboard();
    }
  }, [showDownloads]);
  useEffect(() => {
    if (!pathImage?.data?.url) return;
    const link = document.createElement("a");
    link.href = pathImage.data.url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [pathImage]);
  const columns = [
    { field: "full_name", headerName: "Name", width: 180 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 100,
      renderCell: (cellValues) => {
        const dateTime = cellValues?.row?.created_at || "";
        const formattedDate = dateTime.slice(0, 10);
        const formattedTime = dateTime.slice(11, 19);

        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  fontWeight: "500",
                }}
              >
                {formattedDate}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#888",
                }}
              >
                &nbsp;{formattedTime}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "phone_number",
      headerName: "Phone No.",
      width: 150,
      renderCell: (cellValues) => {
        const phoneNumber = cellValues?.row?.phone_number || "";

        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  fontWeight: "500",
                }}
              >
                &nbsp; {phoneNumber}
              </div>
            </div>
          </div>
        );
      },
    },

    { field: "lead_source", headerName: "Lead Source", width: 150 },
    {
      field: "current_status",
      headerName: "Application Status",
      width: 240, // Slightly increased width for better layout
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;

        const statusConfig = {
          "Lead Details Modified": {
            color: "blue",
            icon: <FileTextOutlined />,
          },
          Assigned: { color: "gold", icon: <CheckCircleOutlined /> },
          "Can Not Process": { color: "error", icon: <WarningOutlined /> },
          "Lead Generated": { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px", // Adds subtle rounding
            }}
          >
            {icon}
            <span>{status}</span>
          </Tag>
        );
      },
    },

    {
      field: "state_name",
      headerName: "Address",
      width: 220,
      renderCell: (cellValues) => {
        const fullAddress = `${cellValues?.row?.address || ""}`;
        const truncatedAddress =
          fullAddress?.length > 50
            ? `${fullAddress.substring(0, 60)}...`
            : fullAddress;

        return (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "220px",
              fontSize: "12px",
            }}
            title={fullAddress}
          >
            {truncatedAddress}
          </div>
        );
      },
    },

    { field: "primary_occupation", headerName: "Occupation", width: 140 },

    {
      field: "time",
      hideable: true,
      headerName: "Product",
      width: 100,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "steelblue",
              }}
            >
              {cellValues?.row?.lead_details[0]?.service_details?.product_name}
            </div>
          </div>
        );
      },
    },

    {
      field: "assigned_emp_name",
      hideable: true,
      headerName: "Assigned Employee",
      width: 150,
    },
  ];

  const onLocationChange = (event) => {
    if (event.ConditionName === "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName === "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName === "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const reportBulkData = async () => {
    const responseData = {
      farmer_id_list: selectedFarmerIds,
      zip_file_name: "Leads",
      background: true,
    };
    multipleDownloadFarmers(responseData)
      .unwrap()
      .then((data) => {
        toast.success("Task Created Successfully !!");
      })
      .catch((error) => {
        toast.error("Error while Creating Task");
        return;
      });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);
    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (value) => {
    setSearchKey(value);
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const filterDataBasedId = (item) => {
    setSelectedFarmerIds(item);
  };
  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };

  // const handleDownload = (fileUrl) => {
  //   if (!fileUrl) return;

  //   const link = document.createElement("a");
  //   link.href = fileUrl;
  //   link.setAttribute("download", "");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  const handleStatusChange = (selectedOption) => {
    if (selectedOption) {
      setStatusName(selectedOption.value);
    } else {
      setStatusName("");
    }
  };
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-center gap-2 mb-3">
        <Button
          size="sm"
          variant={showDownloads ? "outline-warning" : "warning"}
          onClick={() => setShowDownloads(false)}
        >
          Create New Task
        </Button>

        <Button
          size="sm"
          variant={showDownloads ? "warning" : "outline-warning"}
          onClick={() => setShowDownloads(true)}
        >
          Previous Downloads
        </Button>
      </div>

      {!showDownloads ? (
        <>
          <Row style={{ backgroundColor: "#f8f8f8" }}>
            <Col md={2} className="mt-3">
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>
            <Col md={10}>
              <StateDistrict
                onLocationChange={onLocationChange}
                state_id={state_id}
                district_id={district_id}
                block_id={block_id}
                stateName={stateName}
                districtName={districtName}
                blockName={blockName}
                setBlockList={setBlockList}
                blockList={blockList}
                noBlock={true}
                setStateName={setStateName}
                setDistrictName={setDistrictName}
                setStateId={setStateId}
                setDistrictId={setDistrictId}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center my-3">
            <h5 className="mb-0">Select Leads</h5>
            <div className="d-flex gap-2">
              <Button variant="success" size="sm" onClick={reportBulkData}>
                Submit
              </Button>
            </div>
          </div>

          {farmerLoading ? (
            <div className="d-flex flex-column justify-content-center align-items-center py-5">
              <Spinner
                animation="border"
                variant="primary"
                role="status"
                style={{ width: "2rem", height: "2rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <div className="mt-3">
                <strong>Loading farmer data...</strong>
              </div>
            </div>
          ) : (
            <DataGrid
              rows={farmerRows}
              columns={columns}
              rowsPerPageOptions={[3]}
              checkboxSelection
              keepNonExistentRowsSelected
              onRowSelectionModelChange={(selectedIds) => {
                const selectedUserIds = selectedIds
                  .map((id) => farmerRows.find((row) => row.id === id)?.user_id)
                  .filter((userId) => userId);
                setSelectedFarmerIds(selectedUserIds);
              }}
              components={{
                Pagination: CustomPagination,
              }}
            />
          )}
        </>
      ) : (
        <Table striped hover>
          <thead>
            <tr>
              <th className="th-sm">Status</th>
              <th className="th-sm">Created At</th>
              <th className="th-sm">File</th>
            </tr>
          </thead>
          <tbody>
            {reportingData && reportingData.length > 0 ? (
              reportingData.map((field, index) => (
                <tr key={index}>
                  <td>{field.status}</td>
                  {/* <td>
                    {field.created_at?.slice(0, 10)}{" "}
                    <span className="text-muted mx-2">
                      ({field.created_at?.slice(11, 19)})
                    </span>
                  </td> */}
                  <td>
                    {(() => {
                      if (!field.created_at) return "N/A";

                      const date = new Date(field.created_at);

                      const formattedDate = date.toLocaleDateString("en-GB", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      });

                      const formattedTime = date.toLocaleTimeString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      });

                      return (
                        <>
                          {formattedDate}{" "}
                          <span className="text-muted mx-2">
                            ({formattedTime})
                          </span>
                        </>
                      );
                    })()}
                  </td>

                  <td>
                    <Button
                      size="sm"
                      className="text-warning"
                      onClick={() => {
                        setImagePath(field?.results?.zip_file_path);
                        pathRefetch();
                      }}
                    >
                      <i
                        className="mdi mdi-download"
                        style={{ color: "white" }}
                      ></i>
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center text-muted py-3">
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
};
